import { render } from "./GestureIcon.vue?vue&type=template&id=e2cf65d0"
import script from "./GestureIcon.vue?vue&type=script&lang=js"
export * from "./GestureIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__